import Box from "@mui/material/Box";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import { ThemeProvider } from "@mui/material/styles";
import theme from "src/styles/mainstyle";
import Intro from "./Components/Intro";
import Carosouel from "./Components/Carousel";
import StillUnsure from "./Components/StillUnsure";
import Welcome from "./Components/Welcome";
import FAQ from "./Components/FAQ";
import InviteFriends from "./Components/InviteFriends";
import InfoTabs from "./Components/InfoTabs";
import { useEffect } from "react";
import PartnersCarousel from "./Components/PartnersCarousel";

export default function MainPage() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Header />
        <Intro />
        <Carosouel />
        <InfoTabs />
        <PartnersCarousel />
        <StillUnsure />
        <Welcome />
        <FAQ />
        <InviteFriends />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
